import axios from "axios";
// import scienceSVG from "../assets/images/SVG/Science.svg";
// import englishSVG from "../assets/images/SVG/English.svg";
// import mathSVG from "../assets/images/SVG/Maths.svg";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchSubjects(token) {
  try {
    const response = await API.post("/subjects", { token });
    // const response = {
    //   data: [
    //     { id: 1, name: "Science", image: scienceSVG },
    //     { id: 2, name: "English", image: englishSVG },
    //     { id: 3, name: "Maths", image: mathSVG },
    //   ],
    // };
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchSubjects };
